import { render, staticRenderFns } from "./PartnerUsers.vue?vue&type=template&id=24454bd9&scoped=true"
import script from "./PartnerUsers.vue?vue&type=script&lang=ts"
export * from "./PartnerUsers.vue?vue&type=script&lang=ts"
import style0 from "./PartnerUsers.vue?vue&type=style&index=0&id=24454bd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24454bd9",
  null
  
)

export default component.exports